import clsx from 'clsx';
import { useAppSelector } from '../../redux/hooks';
import { selectActiveSidePanelItemKey, selectSidePanelItems } from '../../redux/slices/side-panel-slice';
import SidePanelNavItemComponent from './side-panel-nav-item.component';

interface SidePanelNavProps {
  displayCollapsed: boolean;
}

function SidePanelNav({ displayCollapsed }: SidePanelNavProps) {
  const items = useAppSelector(selectSidePanelItems);
  const activeItemKey = useAppSelector(selectActiveSidePanelItemKey);

  return items.map((item, index) => {
    const recordStyles = clsx('cursor-pointer h-10 border-b border-gray-2', {
      'bg-primary-2 text-mono-1': activeItemKey === item.key,
      'border-t mt-2': index === 0,
    });

    return (
      <SidePanelNavItemComponent
        key={item.key}
        item={item}
        className={recordStyles}
        displayCollapsed={displayCollapsed}
      />
    );
  });
}

export default SidePanelNav;
